// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6fkbH","location":"Header_location__1LzdD"};